import { get } from 'lodash';
import { createSelector } from 'reselect';
import isFuture from 'date-fns/is_future';

export const sessionSelector = state => get(state, ['dal', 'session']);

export const sessionUserSelector = createSelector(
  [sessionSelector],
  session => get(session, 'user'),
);

export const sessionTokenSelector = createSelector(
  [sessionSelector],
  session => get(session, 'token'),
);

const sessionExpiresSelector = createSelector(
  [sessionSelector],
  session => get(session, 'expires'),
);

const hasTokenSelector = createSelector(
  [sessionTokenSelector],
  token => !!token,
);

export const sessionUserEmailSelector = createSelector(
  [sessionSelector],
  session => get(session, ['user', 'email']),
);

export const isAdminSelector = createSelector(
  [sessionSelector],
  session => get(session, ['user', 'isAdmin']),
);

const isExpiredSelector = state => !isFuture(sessionExpiresSelector(state)); // Don't use reselect

export const hasValidSessionSelector = createSelector(
  [hasTokenSelector, isExpiredSelector],
  (hasToken, isExpired) => hasToken && !isExpired,
);

export const isLoggedInSelector = createSelector(
  [sessionSelector],
  session => get(session, 'isLoggedIn'),
);



// WEBPACK FOOTER //
// ./src/lib/dataLayer/session/selectors.js